import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["badge"],
  _excluded2 = ["buttonUse", "options", "referenceToOption", "resetValue", "inputRef"];
import { useIsUngatedForDisplayOptimizedFormControl } from '../v2/hooks/useIsUngatedForDisplayOptimizedFormControl';
import { createTokenizedComponent } from './helpers';
import { ReferenceLiteSearchSelectV2 } from 'reference-resolvers-lite/components/ReferenceLiteSearchSelectV2';
import ReferenceLiteSearchSelect from 'reference-resolvers-lite/components/ReferenceLiteSearchSelect';
import { jsx as _jsx } from "react/jsx-runtime";
export let _capturedPropsForTesting = {};
const TokenizedReferenceLiteSearchSelect = createTokenizedComponent(ReferenceLiteSearchSelect);
const adaptedButtonUse = buttonUse => {
  if (buttonUse === 'view-group') {
    return undefined;
  }
  return buttonUse;
};
const adaptedOption = option => {
  if (!option) {
    return option;
  }
  const {
      badge
    } = option,
    rest = _objectWithoutPropertiesLoose(option, _excluded);
  return Object.assign({}, rest, badge && badge instanceof Object ? badge : {});
};
export default function ReferenceLiteSearchSelectAdapter(_ref) {
  let {
      buttonUse,
      options,
      referenceToOption,
      resetValue,
      inputRef
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded2);
  const isUngatedForDisplayOptimizedFormControl = useIsUngatedForDisplayOptimizedFormControl();
  if (isUngatedForDisplayOptimizedFormControl) {
    _capturedPropsForTesting = Object.assign({
      buttonUse,
      options,
      referenceToOption,
      resetValue,
      inputRef
    }, rest);
    return /*#__PURE__*/_jsx(ReferenceLiteSearchSelectV2, Object.assign({
      "data-test-id": "ReferenceLiteSearchSelectV2",
      buttonUse: buttonUse,
      options: options,
      resetValue: resetValue,
      referenceToOption: referenceToOption,
      ref: inputRef
    }, rest));
  }
  const _buttonUse = adaptedButtonUse(buttonUse);
  const _options = options === null || options === void 0 ? void 0 : options.map(adaptedOption);
  const _referenceToOption = referenceToOption ? reference => adaptedOption(referenceToOption(reference)) : undefined;
  const _resetValue = resetValue || undefined;
  _capturedPropsForTesting = Object.assign({
    buttonUse: _buttonUse,
    options: _options,
    referenceToOption: _referenceToOption,
    resetValue: _resetValue,
    inputRef
  }, rest);
  return /*#__PURE__*/_jsx(TokenizedReferenceLiteSearchSelect, Object.assign({
    "data-test-id": "ReferenceLiteSearchSelect",
    buttonUse: _buttonUse,
    options: _options,
    resetValue: _resetValue,
    referenceToOption: _referenceToOption,
    ref: inputRef
  }, rest));
}